import ScrollReveal from "../../../components/feature/ScrollReveal";
import { viewData } from "../../../mocks/yokohamaData";

export default function ViewSection() {
  return (
    <section className="py-20 md:py-28 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-14">
              <p className="section-label mb-3">{viewData.label}</p>
              <h2 className="section-title">{viewData.title}</h2>
              <p className="section-subtitle max-w-2xl mx-auto">{viewData.description}</p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {viewData.spots.map((spot, idx) => (
              <ScrollReveal key={spot.name} direction="up" delay={idx * 80}>
                <div className="p-5 bg-white rounded-lg h-full">
                  <h3 className="text-base font-serif font-semibold text-airdoa-navy">{spot.name}</h3>
                  <p className="mt-1.5 text-sm text-airdoa-gray leading-[1.8]">{spot.desc}</p>
                  <span className="inline-block mt-3 px-2.5 py-1 text-[10px] font-medium text-airdoa-gold bg-airdoa-cream rounded">
                    {spot.time}
                  </span>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
